// SCSS variable values for use in JS/TS (react-select styles, charts, ...).
// Replaces the ICSS `:export` block of colours.module.scss, which Turbopack does not support.
// Values are the compiled results of variables/colours.scss - keep them in sync when those change.
const colours: Record<string, string> = {
  'background': '#FFFFFF',
  'background-alt': '#EDF0F2',
  'primary-text': '#002244',
  'primary-text-alt': '#002244',
  'light-contrast': '#FFFFFF',
  'gray-900': '#002244',
  'london-grey': '#EDF0F2',
  'primary': '#003CB2',
  'primary-alt': '#003CB2',
  'secondary': '#334E69',
  'secondary-alt': '#002244',
  'tertiary': '#CCD3DA',
  'tertiary-alt': '#334E69',
  'task': '#F47D20',
  'task-alt': '#a8792b',
  'error': '#f00',
  'error-alt': '#f99',
  'danger': '#EB0037',
  'danger-alt': '#EB0037',
  'card-cap-bg': '#EDF0F2',
  'card-border-color': '#CCD3DA',
  'card-border-radius': '0',
  'input-btn-focus-width': '0.1rem',
  'input-disabled-bg': '#FFFFFF',
  'input-focus-border-color': '#003CB2',
  'custom-control-indicator-checked-bg': '#003CB2',
  'input-color': '#002244',
  'input-border-color': '#CCD3DA',
  'select-input-border-color': '#CCD3DA',
  'select-input-focus-border-color': '#003CB2',
  'select-input-focusbox-shadow': '0 0 0 0.1rem rgba(0, 60, 178, 0.25)',
  'select-invalid-input-focusbox-shadow': '0 0 0 0.1rem rgba(235, 0, 55, 0.25)',
  'select-option-background-focus': '#CCD3DA',
  'select-option-background': '#FFFFFF',
  'select-input-invalid-border-color': '#EB0037',
  'select-label-background-color': '#CCD3DA',
  'select-label-font-color': '#002244',
  'light-green': '#66CC00',
  'green': '#227700',
  'content-blue': '#4A95D0',
  'highlighted-pastel': '#E8F8D9',
  'highlighted-grey': '#F2F4F6',
  'purple': '#9423FC',
  'black': '#000000',
}

export default colours
